import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { getCountry } from 'shared/helpers/env';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';
import AgentReports from './AgentReports.vue';
import LabelReports from './LabelReports.vue';
import InboxReports from './InboxReports.vue';
import TeamReports from './TeamReports.vue';
import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';
import CustomReport from './CustomReport.vue';
import CustomDetails from './CustomDetails.vue';
import AIAgentQAScore from './AIAgentQAScore.vue';

// 生成报告路由的函数，根据国家条件过滤路由
const generateReportRoutes = () => {
  const country = getCountry();
  const isIndia = country === 'in';
  
  const allRoutes = [
    {
      path: '',
      redirect: to => {
        return { name: 'account_overview_reports', params: to.params };
      },
    },
    {
      path: 'overview',
      name: 'account_overview_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: LiveReports,
    },
    {
      path: 'conversation',
      name: 'conversation_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: Index,
    },
    {
      path: 'agent',
      name: 'agent_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: AgentReports,
    },
    {
      path: 'label',
      name: 'label_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: LabelReports,
    },
    {
      path: 'inboxes',
      name: 'inbox_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: InboxReports,
    },
    {
      path: 'teams',
      name: 'team_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: TeamReports,
    },
    {
      path: 'sla',
      name: 'sla_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
        featureFlag: FEATURE_FLAGS.SLA,
      },
      component: SLAReports,
    },
    {
      path: 'csat',
      name: 'csat_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: CsatResponses,
    },
    {
      path: 'bot',
      name: 'bot_reports',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: BotReports,
    },
    {
      path: 'custom-report',
      name: 'custom_report',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: CustomReport,
    },
    {
      path: 'custom-details',
      name: 'custom_details',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: CustomDetails,
    },
    {
      path: 'ai-agent-qa-score',
      name: 'ai_agent_qa_score',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: AIAgentQAScore,
    }
  ];

  // 如果是印度环境，过滤掉 custom-report 和 custom-details 路由
  if (isIndia) {
    return allRoutes.filter(route => 
      route.name !== 'custom_details' && 
      route.name !== 'ai_agent_qa_score'
    );
  }

  return allRoutes;
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: generateReportRoutes(),
    },
  ],
};
